import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CoursesSlotStatsStyled } from "../courses.panel.styled";

interface ICoursesCalendarSlotStats {
  /** Slot rows in range (scheduled occurrences) */
  scheduledCoursesCount: number;
  /** Distinct course definitions in those slots */
  courseTemplatesCount: number;
  /** Slots that already have a ride */
  ridesCreatedCount: number;
}

export const CoursesCalendarSlotStats: FC<ICoursesCalendarSlotStats> = ({
  scheduledCoursesCount,
  courseTemplatesCount,
  ridesCreatedCount,
}) => {
  const { t } = useTranslation();

  return (
    <CoursesSlotStatsStyled>
      <span className="courses-slot-stats__pair">
        <span className="courses-slot-stats__label">
          {t("course.calendar.statsScheduledCourses")}:
        </span>
        <span className="courses-slot-stats__value">
          {scheduledCoursesCount}
        </span>
      </span>
      <span className="courses-slot-stats__pair">
        <span className="courses-slot-stats__label">
          {t("course.calendar.statsCourseTemplates")}:
        </span>
        <span className="courses-slot-stats__value">
          {courseTemplatesCount}
        </span>
      </span>
      <span className="courses-slot-stats__pair">
        <span className="courses-slot-stats__label">
          {t("course.calendar.statsRides")}:
        </span>
        <span className="courses-slot-stats__value">{ridesCreatedCount}</span>
      </span>
    </CoursesSlotStatsStyled>
  );
};
